const satisfaction = (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask
			id="mask0_2585_2150"
			// style="mask-type:luminance"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="24"
			height="24"
		>
			<path d="M24 0H7.05719e-05V24H24V0Z" fill="white" />
		</mask>
		<g mask="url(#mask0_2585_2150)">
			<path
				d="M3.41395 17.135L3.41394 17.1351C2.91734 17.5872 3.32602 18.4022 3.98152 18.2845L3.98156 18.2845C4.99584 18.1022 6.5911 17.678 8.03004 16.6962L8.08448 16.6591L8.123 16.6056L15.9408 5.74953L16.0795 5.55687L15.9647 5.34905C15.3987 4.32455 14.6032 3.44492 13.6474 2.77941C13.2969 2.5353 12.9247 2.31995 12.5343 2.13682C11.556 1.67792 10.4641 1.42166 9.31328 1.42165C5.11249 1.42161 1.72601 4.80195 1.71877 9.00281C1.71445 11.5317 2.94659 13.773 4.84272 15.1558C4.9016 15.1988 4.91189 15.2711 4.88297 15.3208L4.88294 15.3209C4.53446 15.9205 4.06015 16.5468 3.41395 17.135Z"
				fill="#DFEBFA"
			/>
			<path
				d="M3.41395 17.135L3.41394 17.1351C2.91734 17.5872 3.32602 18.4022 3.98152 18.2845L3.98156 18.2845C4.99584 18.1022 6.5911 17.678 8.03004 16.6962L8.08448 16.6591L8.123 16.6056L15.9408 5.74953L16.0795 5.55687L15.9647 5.34905C15.3987 4.32455 14.6032 3.44492 13.6474 2.77941C13.2969 2.5353 12.9247 2.31995 12.5343 2.13682C11.556 1.67792 10.4641 1.42166 9.31328 1.42165C5.11249 1.42161 1.72601 4.80195 1.71877 9.00281C1.71445 11.5317 2.94659 13.773 4.84272 15.1558C4.9016 15.1988 4.91189 15.2711 4.88297 15.3208L4.88294 15.3209C4.53446 15.9205 4.06015 16.5468 3.41395 17.135Z"
				fill="white"
			/>
			<path
				d="M3.41395 17.135L3.41394 17.1351C2.91734 17.5872 3.32602 18.4022 3.98152 18.2845L3.98156 18.2845C4.99584 18.1022 6.5911 17.678 8.03004 16.6962L8.08448 16.6591L8.123 16.6056L15.9408 5.74953L16.0795 5.55687L15.9647 5.34905C15.3987 4.32455 14.6032 3.44492 13.6474 2.77941C13.2969 2.5353 12.9247 2.31995 12.5343 2.13682C11.556 1.67792 10.4641 1.42166 9.31328 1.42165C5.11249 1.42161 1.72601 4.80195 1.71877 9.00281C1.71445 11.5317 2.94659 13.773 4.84272 15.1558C4.9016 15.1988 4.91189 15.2711 4.88297 15.3208L4.88294 15.3209C4.53446 15.9205 4.06015 16.5468 3.41395 17.135Z"
				fill="#3DB8A9"
				fill-opacity="0.3"
			/>
			<path
				d="M3.41395 17.135L3.41394 17.1351C2.91734 17.5872 3.32602 18.4022 3.98152 18.2845L3.98156 18.2845C4.99584 18.1022 6.5911 17.678 8.03004 16.6962L8.08448 16.6591L8.123 16.6056L15.9408 5.74953L16.0795 5.55687L15.9647 5.34905C15.3987 4.32455 14.6032 3.44492 13.6474 2.77941C13.2969 2.5353 12.9247 2.31995 12.5343 2.13682C11.556 1.67792 10.4641 1.42166 9.31328 1.42165C5.11249 1.42161 1.72601 4.80195 1.71877 9.00281C1.71445 11.5317 2.94659 13.773 4.84272 15.1558C4.9016 15.1988 4.91189 15.2711 4.88297 15.3208L4.88294 15.3209C4.53446 15.9205 4.06015 16.5468 3.41395 17.135Z"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M15.3291 5.95754L7.8189 16.3865C7.45512 16.6347 7.08022 16.8457 6.70721 17.0256C5.7334 15.7952 5.15181 14.2401 5.15181 12.5491C5.15181 8.56191 8.384 5.32967 12.3712 5.32963C13.4263 5.32963 14.4271 5.55396 15.3291 5.95754Z"
				fill="black"
				fill-opacity="0.2"
			/>
			<path
				d="M18.3936 18.6888L18.3936 18.6889C18.3348 18.7317 18.3245 18.8041 18.3534 18.8539C18.7019 19.4535 19.1762 20.0799 19.8224 20.668L19.8224 20.668C20.319 21.1201 19.9104 21.9352 19.2548 21.8174C18.2118 21.63 16.5529 21.1867 15.082 20.1429L18.3936 18.6888ZM18.3936 18.6888C20.2897 17.306 21.5219 15.0647 21.5176 12.5358C21.5104 8.33494 18.1239 4.95464 13.9231 4.95464C9.72878 4.95468 6.32865 8.35481 6.32865 12.5491C6.32865 16.7434 9.72882 20.1436 13.9231 20.1436C14.2313 20.1436 14.5392 20.1249 14.8452 20.0877L14.8 19.7154M18.3936 18.6888L18.1727 18.3859C19.976 17.0707 21.1467 14.9402 21.1426 12.5364C21.1357 8.54246 17.9171 5.32964 13.9231 5.32964C9.93589 5.32968 6.70365 8.56192 6.70365 12.5491C6.70365 16.5363 9.93593 19.7686 13.9231 19.7686C14.2162 19.7686 14.509 19.7508 14.8 19.7154M14.8 19.7154C14.9759 19.694 15.1545 19.7345 15.299 19.837L14.8453 20.0877M14.8 19.7154L14.8453 20.0877M14.8453 20.0877C14.9357 20.0767 15.0193 20.0984 15.082 20.1428L14.8453 20.0877Z"
				fill="#9269D4"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M18.0181 20.9453C17.341 20.329 16.8433 19.6719 16.4773 19.0423C16.348 18.8199 16.413 18.5374 16.6208 18.3859C18.4241 17.0707 19.5948 14.9402 19.5907 12.5364C19.5843 8.80725 16.7777 5.75947 13.1546 5.37168C13.4136 5.34375 13.674 5.32972 13.9345 5.32964C17.9285 5.3296 21.1472 8.54246 21.154 12.5364C21.1582 14.9402 19.9875 17.0707 18.1841 18.3859C17.9763 18.5374 17.9114 18.8199 18.0407 19.0423C18.4066 19.6719 18.9044 20.329 19.5814 20.9453C19.7977 21.1422 19.6205 21.5 19.3326 21.4483C18.9216 21.3744 18.5148 21.2784 18.1142 21.1606C18.115 21.0848 18.086 21.0071 18.0181 20.9453Z"
				fill="#9269D4"
			/>
			<path
				d="M13.6047 19.7607C13.4516 19.7539 13.2998 19.7422 13.1494 19.7259C13.1822 19.7224 13.2152 19.7194 13.2479 19.7154C13.3688 19.7005 13.4915 19.716 13.6047 19.7607Z"
				fill="#9269D4"
			/>
			<path
				d="M9.96446 13.7889H17.9046C18.2099 13.7889 18.4192 14.1 18.3009 14.3815C17.5847 16.0866 15.8999 17.2842 13.9345 17.2842C11.9692 17.2842 10.2843 16.0866 9.56812 14.3815C9.44986 14.1 9.65916 13.7889 9.96446 13.7889Z"
				fill="#DFEBFA"
			/>
			<path
				d="M9.96446 13.7889H17.9046C18.2099 13.7889 18.4192 14.1 18.3009 14.3815C17.5847 16.0866 15.8999 17.2842 13.9345 17.2842C11.9692 17.2842 10.2843 16.0866 9.56812 14.3815C9.44986 14.1 9.65916 13.7889 9.96446 13.7889Z"
				fill="white"
			/>
			<path
				d="M9.96446 13.7889H17.9046C18.2099 13.7889 18.4192 14.1 18.3009 14.3815C17.5847 16.0866 15.8999 17.2842 13.9345 17.2842C11.9692 17.2842 10.2843 16.0866 9.56812 14.3815C9.44986 14.1 9.65916 13.7889 9.96446 13.7889Z"
				fill="#CCADFF"
			/>
			<path
				d="M16.6029 14.3815C16.7212 14.1 16.5118 13.7889 16.2066 13.7889H17.9046C18.2098 13.7889 18.4192 14.1 18.301 14.3815C17.5847 16.0866 15.8999 17.2843 13.9345 17.2843C13.6446 17.2843 13.361 17.2576 13.0855 17.2077C14.6776 16.9192 15.9924 15.835 16.6029 14.3815Z"
				fill="black"
				fill-opacity="0.2"
			/>
			<path
				d="M9.96569 13.7889H17.9058C18.2111 13.7889 18.4204 14.1 18.3022 14.3815C17.586 16.0866 15.9011 17.2842 13.9357 17.2842C11.9704 17.2842 10.2855 16.0866 9.56935 14.3815C9.45106 14.1 9.6604 13.7889 9.96569 13.7889Z"
				stroke="black"
				stroke-width="0.75"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M17.897 10.8459C17.897 10.0931 17.2867 9.48279 16.5338 9.48279C15.781 9.48279 15.1707 10.0931 15.1707 10.8459"
				stroke="black"
				stroke-width="0.75"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12.7004 10.8459C12.7004 10.0931 12.0901 9.48279 11.3373 9.48279C10.5844 9.48279 9.97409 10.0931 9.97409 10.8459"
				stroke="black"
				stroke-width="0.75"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
	</svg>
);
const waittimes = (
	<svg
		width="25"
		height="25"
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask
			id="mask0_2585_2173"
			// style="mask-type:luminance"
			maskUnits="userSpaceOnUse"
			x="-1"
			y="-1"
			width="27"
			height="26"
		>
			<path
				d="M-0.25 -0.749931H25.2499V24.75H-0.25V-0.749931Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask0_2585_2173)">
			<path
				d="M12.5001 10.2014C9.78445 10.2014 7.5752 7.99211 7.5752 5.27651C7.5752 2.56086 9.78445 0.351556 12.5001 0.351556C15.2158 0.351556 17.425 2.56086 17.425 5.27651C17.425 7.99211 15.2158 10.2014 12.5001 10.2014Z"
				fill="#9269D4"
			/>
			<path
				d="M16.1692 5.27649C16.1692 7.30313 14.5263 8.94604 12.4996 8.94604C10.4729 8.94604 8.83008 7.30313 8.83008 5.27649C8.83008 3.24986 10.4729 1.60689 12.4996 1.60689C14.5263 1.60689 16.1692 3.24986 16.1692 5.27649Z"
				fill="white"
			/>
			<path
				d="M16.1692 5.27649C16.1692 7.30313 14.5263 8.94604 12.4996 8.94604C10.4729 8.94604 8.83008 7.30313 8.83008 5.27649C8.83008 3.24986 10.4729 1.60689 12.4996 1.60689C14.5263 1.60689 16.1692 3.24986 16.1692 5.27649Z"
				fill="#CCADFF"
			/>
			<path
				d="M5.82519 23.0818V23.4568H5.45019H4.31689H3.94189V23.0818V19.3212V18.9462H4.31689H5.45019H5.82519V19.3212V23.0818Z"
				fill="#5A5A5A"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M2.42871 23.0818C2.42871 22.7688 2.6824 22.5151 2.99533 22.5151H6.77293C7.08587 22.5151 7.33956 22.7688 7.33956 23.0818C7.33956 23.3948 7.08587 23.6484 6.77293 23.6484H2.99533C2.6824 23.6484 2.42871 23.3948 2.42871 23.0818Z"
				fill="#838383"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M13.4418 23.0818V23.4568H13.0668H11.9336H11.5586V23.0818V19.3212V18.9462H11.9336H13.0668H13.4418V19.3212V23.0818Z"
				fill="#5A5A5A"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M10.0444 23.0818C10.0444 22.7688 10.2981 22.5151 10.6111 22.5151H14.3887C14.7016 22.5151 14.9553 22.7688 14.9553 23.0818C14.9553 23.3948 14.7016 23.6484 14.3887 23.6484H10.6111C10.2981 23.6484 10.0444 23.3948 10.0444 23.0818Z"
				fill="#838383"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M21.0581 23.0818V23.4568H20.6831H19.5498H19.1748V23.0818V19.3212V18.9462H19.5498H20.6831H21.0581V19.3212V23.0818Z"
				fill="#5A5A5A"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M17.6606 23.0818C17.6606 22.7688 17.9143 22.5151 18.2273 22.5151H22.0049C22.3178 22.5151 22.5715 22.7688 22.5715 23.0818C22.5715 23.3948 22.3178 23.6484 22.0049 23.6484H18.2273C17.9143 23.6484 17.6606 23.3948 17.6606 23.0818Z"
				fill="#838383"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M4.31689 21.3942H5.45019V19.6401H4.31689V21.3942ZM11.933 21.3942H13.0663V19.6401H11.933V21.3942ZM19.5492 21.3942H20.6825V19.6401H19.5492V21.3942Z"
				fill="#444444"
			/>
			<path
				d="M8.08043 18.4443H1.6875V14.3708C1.6875 13.0898 2.72597 12.0513 4.00696 12.0513H5.76097C7.04197 12.0513 8.08043 13.0898 8.08043 14.3708V18.4443Z"
				fill="#9269D4"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M1.07568 19.852V18.7904C1.07568 18.6986 1.11216 18.6105 1.17709 18.5456C1.24202 18.4807 1.33008 18.4442 1.4219 18.4442H8.34565C8.39111 18.4442 8.43613 18.4531 8.47813 18.4705C8.52013 18.4879 8.5583 18.5134 8.59044 18.5456C8.62259 18.5777 8.64809 18.6159 8.66548 18.6579C8.68287 18.6999 8.69182 18.7449 8.69182 18.7904V19.852C8.69182 19.9438 8.65535 20.0319 8.59043 20.0968C8.52551 20.1617 8.43746 20.1982 8.34565 20.1982H1.4219C1.33008 20.1982 1.24202 20.1618 1.17709 20.0968C1.11216 20.0319 1.07568 19.9438 1.07568 19.852Z"
				fill="#9269D4"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M15.6962 18.4443H9.30322V14.3708C9.30322 13.0898 10.3417 12.0513 11.6227 12.0513H13.3767C14.6577 12.0513 15.6962 13.0898 15.6962 14.3708V18.4443Z"
				fill="#9269D4"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M8.69189 19.852V18.7904C8.69189 18.6986 8.72837 18.6105 8.7933 18.5456C8.85823 18.4807 8.94629 18.4442 9.03811 18.4442H15.9619C16.0537 18.4442 16.1417 18.4807 16.2067 18.5456C16.2716 18.6105 16.3081 18.6986 16.3081 18.7904V19.852C16.3081 19.9438 16.2716 20.0319 16.2067 20.0968C16.1417 20.1618 16.0537 20.1982 15.9619 20.1982H9.03811C8.94629 20.1982 8.85823 20.1618 8.7933 20.0968C8.72837 20.0319 8.69189 19.9438 8.69189 19.852Z"
				fill="#9269D4"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M23.3124 18.4443H16.9194V14.3708C16.9194 13.0898 17.9579 12.0513 19.2389 12.0513H20.993C22.2739 12.0513 23.3124 13.0898 23.3124 14.3708V18.4443Z"
				fill="#9269D4"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M16.3076 19.852V18.7904C16.3076 18.7449 16.3166 18.6999 16.334 18.6579C16.3513 18.6159 16.3768 18.5777 16.409 18.5456C16.4411 18.5134 16.4793 18.4879 16.5213 18.4705C16.5633 18.4531 16.6083 18.4442 16.6538 18.4442H23.5775C23.6694 18.4442 23.7574 18.4807 23.8223 18.5456C23.8873 18.6105 23.9238 18.6986 23.9238 18.7904V19.852C23.9238 19.9438 23.8873 20.0319 23.8223 20.0968C23.7574 20.1618 23.6694 20.1982 23.5775 20.1982H16.6538C16.562 20.1982 16.4739 20.1617 16.409 20.0968C16.3441 20.0319 16.3076 19.9438 16.3076 19.852Z"
				fill="#9269D4"
				stroke="black"
				stroke-width="0.75"
			/>
			<path
				d="M12.4998 0.351617C12.2872 0.351617 12.0777 0.365164 11.8721 0.391461C14.2924 0.700647 16.1693 2.77355 16.1693 5.27652C16.1693 7.77955 14.2924 9.8524 11.8721 10.1616C12.0777 10.1879 12.2872 10.2015 12.4998 10.2015C15.2154 10.2015 17.4247 7.99212 17.4247 5.27652C17.4247 2.56092 15.2154 0.351617 12.4998 0.351617Z"
				fill="#9269D4"
			/>
			<path
				d="M12.5 3.39574V5.27655H13.9501"
				stroke="black"
				stroke-width="0.75"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12.5 8.25043V8.91296"
				stroke="black"
				stroke-width="0.75"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M16.1528 5.25989H15.4902"
				stroke="black"
				stroke-width="0.75"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M9.5097 5.25989H8.84717"
				stroke="black"
				stroke-width="0.75"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M16.5442 5.27649C16.5442 7.51023 14.7334 9.32104 12.4996 9.32104C10.2658 9.32104 8.45508 7.51023 8.45508 5.27649C8.45508 3.04276 10.2658 1.23189 12.4996 1.23189C14.7334 1.23189 16.5442 3.04276 16.5442 5.27649Z"
				stroke="black"
				stroke-width="0.75"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12.4971 1.61091V2.27344"
				stroke="black"
				stroke-width="0.75"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
	</svg>
);
const technologies = (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_2217)">
			<path
				d="M14.1195 4.5291C14.1195 4.24879 14.0582 3.97187 13.9398 3.7178C13.8214 3.46372 13.6488 3.23864 13.4341 3.05836C12.9265 1.44668 11.4321 0.350586 9.74242 0.350586H7.96868C6.27899 0.350586 4.78459 1.44668 4.27696 3.05831C4.0623 3.23859 3.88971 3.46367 3.77131 3.71774C3.6529 3.97182 3.59155 4.24874 3.59155 4.52905V9.69484H14.1195V4.5291H14.1195Z"
				fill="#9269D4"
			/>
			<path
				d="M11.1776 16.2457C11.1594 16.2382 11.1438 16.2256 11.1328 16.2092C11.1218 16.1929 11.1159 16.1737 11.1159 16.154V12.1818H6.59996V16.154C6.59996 16.1942 6.57565 16.2302 6.53826 16.2457L5.68799 17.8915L8.79229 20.0217L12.0096 16.9632L11.1776 16.2457Z"
				fill="#CCADFF"
			/>
			<path
				d="M7.55729 14.077V14.1786H6.59998V16.154C6.59998 16.1942 6.57568 16.2302 6.53828 16.2457L5.68801 17.8915L7.08107 18.8474L7.71057 17.6289C7.74796 17.6135 7.77227 17.5775 7.77227 17.5373V16.0768C7.77227 15.903 7.93036 15.7745 8.1013 15.8057C8.33557 15.8485 8.57323 15.87 8.81138 15.8701C9.26747 15.8703 9.72022 15.7923 10.15 15.6396L10.1844 15.6274C10.5085 15.5124 10.8205 15.3658 11.1158 15.1896V14.077H7.55729ZM4.40882 10.5689C3.71262 10.5689 3.14819 10.0045 3.14819 9.30824C3.14819 8.61204 3.71258 8.04761 4.40882 8.04761H7.11921V10.5688H4.40882V10.5689Z"
				fill="#9269D4"
			/>
			<path
				d="M13.349 10.5689C14.0452 10.5689 14.6096 10.0045 14.6096 9.30824C14.6096 8.61204 14.0453 8.04761 13.349 8.04761H11.5156V10.5688H13.349V10.5689Z"
				fill="#9269D4"
			/>
			<path
				d="M12.1892 5.02301L9.50768 5.71884L7.339 5.21905L5.87102 5.43894L5.6897 8.0233L6.28909 13.2155L8.12813 14.8147L9.78015 15.0937C9.84351 15.0757 9.90631 15.0557 9.96848 15.0339L10.003 15.0217C11.8201 14.3771 13.0344 12.658 13.0344 10.73V6.10485C13.0344 6.10209 13.0342 6.09938 13.0342 6.09657L12.1892 5.02301Z"
				fill="#C0EFE9"
			/>
			<path
				d="M10.0462 9.37831H11.3838C11.6377 9.37831 11.8436 9.17245 11.8436 8.91853V8.02307C11.8436 7.76915 11.6377 7.56329 11.3838 7.56329H10.0462C9.79229 7.56329 9.58643 7.76915 9.58643 8.02307V8.91853C9.58643 9.17245 9.79229 9.37831 10.0462 9.37831Z"
				fill="#9269D4"
			/>
			<path
				d="M12.1875 18.6301L11.7066 16.4602L11.1776 16.2457L9.09647 18.0027C9.02181 18.0654 8.92723 18.0993 8.82978 18.0983C8.73233 18.0974 8.63842 18.0616 8.56499 17.9976L6.53833 16.2523L6.05079 16.451L4.44897 18.7728L7.56935 23.07L8.84265 23.5587H8.85013L8.85092 23.5567C8.9941 23.522 11.0116 23.0343 11.0374 23.0343C11.0641 23.0343 12.1875 18.6301 12.1875 18.6301Z"
				fill="#9269D4"
			/>
			<path
				d="M6.0213 18.0408L7.77414 17.3046L6.53824 16.2457L6.0507 16.451L5.01196 18.0408H6.0213Z"
				fill="#9269D4"
			/>
			<path
				d="M8.79236 23.5924H0.740802C0.484179 23.5924 0.276123 23.3844 0.276123 23.1278V22.3327C0.276123 20.1727 1.58308 18.2277 3.58277 17.412L6.0508 16.4509L8.79236 23.5924Z"
				fill="#F9F3F1"
			/>
			<path
				d="M2.07323 23.1621C2.07323 21.002 3.38019 19.057 5.37988 18.2414L6.57437 17.8148L6.0508 16.4509L3.58277 17.412C1.58308 18.2277 0.276123 20.1727 0.276123 22.3327V23.1278C0.276123 23.3844 0.484179 23.5924 0.740802 23.5924H2.07328L2.07323 23.1621Z"
				fill="#F3EAE6"
			/>
			<path
				d="M5.59672 22.8141H2.70899C2.64424 22.8141 2.58214 22.7883 2.53635 22.7426C2.49057 22.6968 2.46484 22.6347 2.46484 22.5699V21.493C2.46484 21.4283 2.49057 21.3662 2.53635 21.3204C2.58214 21.2746 2.64424 21.2489 2.70899 21.2489H5.59667C5.66142 21.2489 5.72352 21.2746 5.76931 21.3204C5.81509 21.3662 5.84082 21.4283 5.84082 21.493V22.5699C5.84082 22.602 5.83451 22.6337 5.82225 22.6634C5.80998 22.693 5.792 22.7199 5.76934 22.7426C5.74667 22.7652 5.71976 22.7832 5.69014 22.7955C5.66052 22.8078 5.62878 22.8141 5.59672 22.8141Z"
				fill="#F3EAE6"
			/>
			<path
				d="M11.0271 4.57385L9.26053 5.05765C9.01329 5.12538 8.75297 5.12964 8.50365 5.07004L7.37129 4.79939L6.68995 4.63654C5.69202 4.39805 4.7334 5.1546 4.7334 6.18057V10.7439C4.7334 12.6651 5.93915 14.3797 7.7472 15.0295C8.4016 15.2645 9.11345 15.2871 9.78144 15.0941C9.71355 15.0747 9.6463 15.0532 9.57979 15.0295C7.77174 14.3797 6.56599 12.6651 6.56599 10.7439V6.18057C6.56599 6.14472 6.56715 6.1092 6.56949 6.07405C6.58665 5.81322 6.83285 5.6232 7.08727 5.68327L7.09167 5.6843L8.90537 6.1178C9.15469 6.1774 9.41501 6.17314 9.66224 6.10541L11.4288 5.62161C12.0424 5.45357 12.6508 5.66798 13.0341 6.097C13.0292 5.05344 12.035 4.29783 11.0271 4.57385Z"
				fill="#CCADFF"
			/>
			<path
				d="M7.66653 9.37831H6.32891C6.075 9.37831 5.86914 9.17245 5.86914 8.91853V8.02307C5.86914 7.76915 6.075 7.56329 6.32891 7.56329H7.66653C7.92044 7.56329 8.1263 7.76915 8.1263 8.02307V8.91853C8.1263 9.17245 7.92044 9.37831 7.66653 9.37831Z"
				fill="#9269D4"
			/>
			<path
				d="M17.264 22.2989V23.3873C17.264 23.4327 17.2459 23.4763 17.2138 23.5085C17.1816 23.5406 17.1381 23.5586 17.0926 23.5586H8.8501L11.7066 16.4601L13.9573 17.3782C15.957 18.1939 17.264 20.1389 17.264 22.2989Z"
				fill="#F9F3F1"
			/>
			<path
				d="M18.013 23.6494C21.1196 23.6494 23.6379 21.1311 23.6379 18.0246C23.6379 14.9181 21.1196 12.3997 18.013 12.3997C14.9065 12.3997 12.3882 14.9181 12.3882 18.0246C12.3882 21.1311 14.9065 23.6494 18.013 23.6494Z"
				fill="#9269D4"
			/>
			<path
				d="M14.5006 18.0246C14.5006 15.2791 16.4684 12.993 19.07 12.4987C18.7215 12.4327 18.3677 12.3996 18.013 12.3998C14.9065 12.3998 12.3882 14.9181 12.3882 18.0246C12.3882 21.1311 14.9065 23.6495 18.013 23.6495C18.3741 23.6495 18.7285 23.6154 19.0706 23.5504C16.4691 23.056 14.5006 20.77 14.5006 18.0246Z"
				fill="#9269D4"
			/>
			<path
				d="M20.8689 16.7322H19.3055V15.1687C19.3055 15.1223 19.2871 15.0778 19.2542 15.045C19.2214 15.0122 19.1769 14.9937 19.1305 14.9937H16.8957C16.8493 14.9937 16.8047 15.0122 16.7719 15.045C16.7391 15.0778 16.7207 15.1223 16.7207 15.1687V16.7322H15.1572C15.1108 16.7322 15.0663 16.7506 15.0334 16.7834C15.0006 16.8162 14.9822 16.8608 14.9822 16.9072V19.142C14.9822 19.1884 15.0006 19.2329 15.0334 19.2657C15.0663 19.2986 15.1108 19.317 15.1572 19.317H16.7207V20.8804C16.7207 20.9268 16.7391 20.9714 16.7719 21.0042C16.8047 21.037 16.8493 21.0554 16.8957 21.0554H19.1305C19.1769 21.0554 19.2214 21.037 19.2542 21.0042C19.2871 20.9714 19.3055 20.9268 19.3055 20.8804V19.317H20.8689C20.9154 19.317 20.9599 19.2986 20.9927 19.2657C21.0255 19.2329 21.0439 19.1884 21.0439 19.142V16.9072C21.044 16.8842 21.0394 16.8614 21.0306 16.8402C21.0218 16.819 21.009 16.7997 20.9927 16.7834C20.9765 16.7672 20.9572 16.7543 20.9359 16.7455C20.9147 16.7367 20.8919 16.7322 20.8689 16.7322Z"
				fill="white"
			/>
			<path
				d="M20.8689 16.7322H19.3055V15.1687C19.3055 15.1223 19.2871 15.0778 19.2542 15.045C19.2214 15.0122 19.1769 14.9937 19.1305 14.9937H16.8957C16.8493 14.9937 16.8047 15.0122 16.7719 15.045C16.7391 15.0778 16.7207 15.1223 16.7207 15.1687V16.7322H15.1572C15.1108 16.7322 15.0663 16.7506 15.0334 16.7834C15.0006 16.8162 14.9822 16.8608 14.9822 16.9072V19.142C14.9822 19.1884 15.0006 19.2329 15.0334 19.2657C15.0663 19.2986 15.1108 19.317 15.1572 19.317H16.7207V20.8804C16.7207 20.9268 16.7391 20.9714 16.7719 21.0042C16.8047 21.037 16.8493 21.0554 16.8957 21.0554H19.1305C19.1769 21.0554 19.2214 21.037 19.2542 21.0042C19.2871 20.9714 19.3055 20.9268 19.3055 20.8804V19.317H20.8689C20.9154 19.317 20.9599 19.2986 20.9927 19.2657C21.0255 19.2329 21.0439 19.1884 21.0439 19.142V16.9072C21.044 16.8842 21.0394 16.8614 21.0306 16.8402C21.0218 16.819 21.009 16.7997 20.9927 16.7834C20.9765 16.7672 20.9572 16.7543 20.9359 16.7455C20.9147 16.7367 20.8919 16.7322 20.8689 16.7322Z"
				fill="#98E3DA"
				fill-opacity="0.4"
			/>
			<path
				d="M2.64817 17.9924C2.59056 17.9194 2.50631 17.8723 2.41398 17.8614C2.32164 17.8505 2.22876 17.8768 2.15577 17.9344C0.785762 19.0158 0 20.6364 0 22.3807V23.6404C0 23.7334 0.0369358 23.8226 0.102682 23.8883C0.168428 23.9541 0.257599 23.991 0.350578 23.991C0.443557 23.991 0.532728 23.9541 0.598474 23.8883C0.66422 23.8226 0.701156 23.7334 0.701156 23.6404V22.3807C0.701156 20.8524 1.38969 19.4324 2.59021 18.4848C2.62635 18.4562 2.65651 18.4209 2.67898 18.3807C2.70145 18.3405 2.71579 18.2963 2.72117 18.2506C2.72655 18.2048 2.72288 18.1585 2.71035 18.1142C2.69783 18.0699 2.6767 18.0285 2.64817 17.9924ZM5.67212 20.9505H2.78443C2.45652 20.9505 2.18971 21.2173 2.18971 21.5452V22.6221C2.18971 22.95 2.45652 23.2168 2.78443 23.2168H5.67212C6.00002 23.2168 6.26684 22.95 6.26684 22.6221V21.5452C6.26684 21.2173 6.00002 20.9505 5.67212 20.9505ZM5.56568 22.5157H2.89087V21.6517H5.56568V22.5157ZM22.201 13.774C22.1682 13.7416 22.1294 13.716 22.0868 13.6986C22.0442 13.6813 21.9985 13.6725 21.9525 13.6728C21.9064 13.673 21.8609 13.6824 21.8185 13.7003C21.7761 13.7181 21.7376 13.7442 21.7052 13.777C21.6399 13.8431 21.6035 13.9325 21.604 14.0255C21.6046 14.1184 21.642 14.2074 21.7082 14.2727C22.7191 15.2716 23.2759 16.604 23.2759 18.0246C23.2759 20.9328 20.9099 23.2988 18.0016 23.2988C15.0934 23.2988 12.7274 20.9328 12.7274 18.0246C12.7274 15.1164 15.0934 12.7503 18.0016 12.7503C18.9081 12.7503 19.8022 12.9843 20.5874 13.427C20.6684 13.4721 20.7639 13.4833 20.853 13.4581C20.9422 13.433 21.0178 13.3736 21.0633 13.2929C21.1088 13.2122 21.1205 13.1168 21.0959 13.0275C21.0712 12.9382 21.0122 12.8622 20.9318 12.8163C20.0416 12.3144 19.0284 12.0492 18.0016 12.0492C15.2777 12.0492 12.9738 13.8813 12.257 16.378L11.4281 16.0397V14.6382C12.5797 13.7639 13.3106 12.4048 13.368 10.9187C14.2423 10.9023 14.9486 10.1865 14.9486 9.30831C14.9486 8.85536 14.7605 8.44575 14.4585 8.15276V4.52909C14.4589 4.21504 14.3939 3.90436 14.2678 3.61674C14.1417 3.32913 13.9572 3.07088 13.7259 2.85838C13.1425 1.14438 11.5494 0 9.73087 0H7.95718C7.26303 0.000685533 6.5797 0.17208 5.9674 0.499083C5.88541 0.542938 5.8242 0.617567 5.79723 0.706552C5.77027 0.795537 5.77976 0.891589 5.82361 0.973578C5.86747 1.05557 5.9421 1.11678 6.03108 1.14374C6.12007 1.17071 6.21612 1.16122 6.29811 1.11736C6.80864 0.84468 7.3784 0.701746 7.95718 0.701156H9.73087C11.2751 0.701156 12.6243 1.69077 13.0882 3.16366C13.1082 3.2273 13.146 3.28389 13.1971 3.3268C13.3728 3.47401 13.514 3.65798 13.6108 3.86572C13.7076 4.07346 13.7576 4.29991 13.7574 4.52909V7.75296C13.6315 7.71905 13.502 7.70057 13.3717 7.69794V6.10464C13.3717 5.4951 13.0939 4.93347 12.6092 4.56378C12.1247 4.19403 11.5096 4.07428 10.9217 4.23535L9.15508 4.71915C8.96471 4.77115 8.76431 4.77443 8.57233 4.72869L6.75863 4.29523C6.17788 4.15645 5.5761 4.28897 5.10745 4.65881C4.6388 5.02864 4.36998 5.58321 4.36998 6.18022V7.6978C4.22105 7.70013 4.07316 7.72318 3.93059 7.76628V4.52909C3.93034 4.29991 3.98039 4.07346 4.07719 3.86572C4.174 3.65798 4.31521 3.47402 4.49086 3.3268C4.54195 3.28389 4.57975 3.2273 4.59982 3.16366C4.73577 2.73083 4.95457 2.32856 5.24404 1.97922C5.30239 1.90747 5.33003 1.81557 5.32093 1.72354C5.31184 1.6315 5.26674 1.54679 5.19547 1.48786C5.12421 1.42892 5.03253 1.40053 4.94043 1.40887C4.84832 1.41721 4.76325 1.46161 4.70373 1.5324C4.37792 1.92558 4.12659 2.37492 3.96209 2.85833C3.73085 3.07083 3.54631 3.32908 3.42019 3.61669C3.29407 3.9043 3.22912 4.215 3.22948 4.52905V8.19997C2.95504 8.48899 2.78616 8.87911 2.78616 9.30822C2.78616 10.1886 3.4961 10.906 4.37348 10.9188C4.42537 12.3637 5.11587 13.6913 6.21093 14.5706V16.0396L3.53153 17.1328C3.45627 17.1635 3.39402 17.2194 3.35543 17.291C3.31683 17.3625 3.30429 17.4452 3.31995 17.525C3.33561 17.6048 3.3785 17.6766 3.44127 17.7283C3.50405 17.7799 3.58282 17.8081 3.6641 17.8081C3.70949 17.8081 3.75443 17.7992 3.79643 17.782L5.81819 16.9571L8.54541 23.7795C8.57139 23.8445 8.61625 23.9002 8.6742 23.9395C8.73215 23.9788 8.80054 23.9998 8.87055 23.9999H8.87093C8.94087 23.9999 9.00922 23.979 9.06718 23.9398C9.12514 23.9007 9.17006 23.8451 9.19617 23.7802L11.9247 16.9994L12.1025 17.072C12.0518 17.3869 12.0263 17.7054 12.0263 18.0245C12.0263 21.3193 14.7068 23.9999 18.0017 23.9999C21.2965 23.9999 23.9771 21.3193 23.9771 18.0245C23.977 16.4151 23.3463 14.9056 22.201 13.774ZM14.2475 9.30826C14.2475 9.79846 13.8576 10.1983 13.3718 10.2166V8.39999C13.8576 8.41822 14.2475 8.81806 14.2475 9.30826ZM3.48731 9.30826C3.48731 8.81568 3.88094 8.41424 4.37002 8.39961V10.2169C3.88094 10.2023 3.48731 9.8008 3.48731 9.30826ZM5.07118 10.7435V6.18013C5.07118 5.79907 5.24273 5.44513 5.54184 5.20912C5.76317 5.03444 6.03106 4.94273 6.30559 4.94273C6.40202 4.94273 6.49934 4.95404 6.59568 4.97708L8.40934 5.41054C8.71603 5.48367 9.03619 5.47843 9.34033 5.3953L11.1069 4.9115C11.4821 4.80871 11.8747 4.88519 12.1839 5.12115C12.4932 5.35711 12.6706 5.71554 12.6706 6.10459V10.7297C12.6706 12.5054 11.5462 14.0973 9.87255 14.691L9.83806 14.7033C9.19562 14.9305 8.49444 14.9291 7.85294 14.6992C6.18905 14.1012 5.07118 12.5116 5.07118 10.7435ZM7.61581 15.359C8.01216 15.5013 8.43011 15.5739 8.8512 15.5737C9.26729 15.5738 9.68035 15.5029 10.0726 15.3641L10.107 15.3518C10.3197 15.2761 10.5268 15.1857 10.727 15.0813V16.2088C10.727 16.231 10.7288 16.2528 10.7318 16.2743L8.89514 17.816C8.88459 17.825 8.87117 17.8298 8.85733 17.8297C8.84349 17.8296 8.83017 17.8244 8.81979 17.8153L6.91204 16.1499V15.041C7.13784 15.1655 7.37317 15.2718 7.61581 15.359ZM8.87196 22.7076L6.46746 16.6925L8.35871 18.3435C8.50254 18.4691 8.68007 18.532 8.85784 18.532C9.03075 18.532 9.20379 18.4725 9.34594 18.3531L11.2745 16.7342L11.2754 16.7346L8.87196 22.7076Z"
				fill="black"
			/>
			<path
				d="M8.47707 8.91853V8.37364H9.23586V8.91853C9.23586 9.36535 9.59938 9.72883 10.0462 9.72883H11.3838C11.8306 9.72883 12.1941 9.3653 12.1941 8.91853V8.02306C12.1941 7.57623 11.8306 7.21271 11.3838 7.21271H10.0462C9.72503 7.21271 9.44775 7.40095 9.31673 7.67248H8.3962C8.26518 7.40095 7.9879 7.21271 7.66677 7.21271H6.32915C5.88232 7.21271 5.5188 7.57623 5.5188 8.02306V8.91853C5.5188 9.36535 5.88232 9.72883 6.32915 9.72883H7.66677C8.11354 9.72888 8.47707 9.36535 8.47707 8.91853ZM9.93701 8.02306C9.93705 7.99412 9.94856 7.96637 9.96902 7.9459C9.98948 7.92543 10.0172 7.91391 10.0462 7.91386H11.3838C11.4127 7.9139 11.4405 7.92542 11.4609 7.94589C11.4814 7.96636 11.4929 7.99411 11.4929 8.02306V8.91853C11.4929 8.94746 11.4814 8.9752 11.4609 8.99566C11.4405 9.01612 11.4127 9.02764 11.3838 9.02767H10.0462C10.0172 9.02764 9.98948 9.01612 9.96902 8.99566C9.94856 8.9752 9.93705 8.94746 9.93701 8.91853V8.02306ZM6.21995 8.91853V8.02306C6.21999 7.99411 6.23151 7.96636 6.25198 7.94589C6.27245 7.92542 6.3002 7.9139 6.32915 7.91386H7.66677C7.69571 7.9139 7.72346 7.92542 7.74392 7.94589C7.76438 7.96636 7.77589 7.99411 7.77591 8.02306V8.91853C7.77588 8.94746 7.76436 8.9752 7.7439 8.99566C7.72344 9.01612 7.6957 9.02764 7.66677 9.02767H6.32915C6.3002 9.02766 6.27244 9.01616 6.25197 8.99569C6.23149 8.97523 6.21998 8.94747 6.21995 8.91853ZM19.6562 16.3816V15.1687C19.6562 14.8789 19.4204 14.6431 19.1306 14.6431H16.8958C16.6059 14.6431 16.3702 14.8789 16.3702 15.1687V16.3816H15.1573C14.8675 16.3816 14.6317 16.6174 14.6317 16.9072V19.142C14.6317 19.4318 14.8675 19.6676 15.1573 19.6676H16.3702V20.8805C16.3702 21.1703 16.6059 21.4061 16.8958 21.4061H19.1306C19.4204 21.4061 19.6562 21.1703 19.6562 20.8805V19.6676H20.8691C21.1589 19.6676 21.3946 19.4318 21.3946 19.142V16.9072C21.3946 16.6174 21.1589 16.3816 20.8691 16.3816H19.6562ZM20.6935 18.9664H19.3056C19.2126 18.9664 19.1235 19.0034 19.0577 19.0691C18.992 19.1348 18.955 19.224 18.955 19.317V20.7049H17.0713V19.317C17.0713 19.224 17.0344 19.1348 16.9686 19.0691C16.9029 19.0034 16.8137 18.9664 16.7207 18.9664H15.3329V17.0827H16.7207C16.8137 17.0827 16.9029 17.0458 16.9686 16.98C17.0344 16.9143 17.0713 16.8251 17.0713 16.7321V15.3442H18.955V16.7321C18.955 16.8251 18.992 16.9143 19.0577 16.98C19.1235 17.0458 19.2126 17.0827 19.3056 17.0827H20.6935V18.9664Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_2217">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const waittimes2 = (
	<svg
		width="26"
		height="26"
		viewBox="0 0 26 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask
			id="mask0_2585_2242"
			// style="mask-type:luminance"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="27"
			height="26"
		>
			<path
				d="M0.540039 0.0400295H26.46V25.96H0.540039V0.0400295Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask0_2585_2242)">
			<path
				d="M12.2784 25.0877L12.2784 25.0877C6.1424 24.4747 1.35156 19.2971 1.35156 13C1.35156 6.70961 6.13204 1.53645 12.2584 0.914255L12.2585 0.914251C12.57 0.882631 12.9005 0.888885 13.1953 0.894466C13.3025 0.896494 13.4049 0.898432 13.5 0.898432C20.2334 0.898432 25.1796 6.31521 25.1796 13C25.1796 19.6847 20.2334 25.1015 13.5 25.1015C13.4052 25.1015 13.3025 25.1036 13.1948 25.1057C12.9067 25.1115 12.5825 25.118 12.2784 25.0877Z"
				fill="#9AE3DA"
				fill-opacity="0.5"
				stroke="black"
			/>
			<path
				d="M14.073 1.95992C13.7176 1.95992 13.3663 1.9788 13.02 2.01532C18.3063 2.57234 22.434 7.2776 22.434 12.9999C22.434 18.7222 18.3063 23.4275 13.02 23.9845C13.3699 24.0214 13.7214 24.0399 14.073 24.0399C19.8538 24.0399 24.54 19.0972 24.54 12.9999C24.54 6.90268 19.8538 1.95992 14.073 1.95992Z"
				fill="#9269D4"
			/>
			<path
				d="M17.9782 16.5001C15.5049 18.9734 11.495 18.9734 9.02173 16.5001"
				stroke="black"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.159 10.3541C9.58476 11.3487 8.14917 11.3487 7.57495 10.3541"
				stroke="black"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M19.4248 10.3541C18.8506 11.3487 17.415 11.3487 16.8408 10.3541"
				stroke="black"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M8.9843 7.9667L6.75366 8.93274"
				stroke="black"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M18.0159 7.9667L20.2465 8.93274"
				stroke="black"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
	</svg>
);

export const highlightIcons = {
	satisfaction,
	waittimes,
	technologies,
	waittimes2,
};
